import React, { useMemo } from 'react';
import { Formik, Field, Form } from 'formik';
import { HiOutlineRefresh } from 'react-icons/hi';
import 'bootstrap/dist/css/bootstrap.min.css';

import './DataFilterTickets.css'
import getTicketFilterOptions from '../../shared/utilities/getTicketFilterOptions.js';

const DataFilterTickets = (props) => {
    const {user, dataTicketsAux, formikValues, setFormikValues, resetTicketFilters} = props
    const options = useMemo(
        () => getTicketFilterOptions(dataTicketsAux, formikValues),
        [dataTicketsAux, formikValues]
    );

    return(
        <div className = 'row'>
            <Formik
                initialValues={formikValues}
                enableReinitialize={true}
                onSubmit={async (values, { setSubmitting }) => {
                    setFormikValues(values);
                    setSubmitting(false);
                }}
            >
                {({ setValues, values }) => {
                    const handleFilterChange = (event) => {
                        const nextValues = {...values, [event.target.name]: event.target.value};
                        setValues(nextValues, false);
                        setFormikValues(nextValues);
                    };

                    return (
                    <Form>
                        <div className="row filtersRow" style={{marginBottom: "10px"}}>
                            <div className="form-group col-auto resetFilterCol">
                                <label className='labelFilter labelFilterHidden'>Reset</label>
                                <button
                                    type="button"
                                    className="btn resetFiltersIconButton"
                                    onClick={resetTicketFilters}
                                    title="Reset filtros"
                                    aria-label="Reset filtros"
                                >
                                <HiOutlineRefresh />
                            </button>
                            </div>
                            <div className="form-group col">
                                <label htmlFor="id" className='labelFilter'>Id</label>
                                <Field id="id" name="id" className="form-control fieldFilter" type="text" onChange={handleFilterChange}/>
                            </div>
                            <div className="form-group col">
                                <label htmlFor="tipo" className='labelFilter'>Tipo</label>
                                <Field id="tipo" name="tipo" className="form-control fieldFilter" as="select" onChange={handleFilterChange}>
                                    <option value="*" defaultValue>*</option>
                                    {options.tipo.map((type, i) => (
                                        <option key={i} value={type}>{type}</option>
                                    ))}
                                </Field>
                            </div>
                            <div className="form-group col">
                                <label htmlFor="asunto" className='labelFilter'>Asunto</label>
                                <Field id="asunto" name="asunto" className="form-control fieldFilter" type="text" onChange={handleFilterChange}/>
                            </div>
                            <div className="form-group col">
                                <label htmlFor="instalacion" className='labelFilter'>Instalación</label>
                                <Field id="instalacion" name="instalacion" className="form-control fieldFilter" as="select" onChange={handleFilterChange}>
                                    {user.installationId == "A01" ? <option value="*" defaultValue>*</option> : <></>}
                                    {options.instalacion.map((installation, i) => (
                                        <option key={i} value={installation}>{installation}</option>
                                    ))}
                                </Field>
                            </div>
                            <div className="form-group col">
                                <label htmlFor="usuario" className='labelFilter'>Usuario</label>
                                <Field id="usuario" name="usuario" className="form-control fieldFilter" as="select" onChange={handleFilterChange}>
                                    <option value="*">*</option>
                                    {options.usuario.map((u, i) => (
                                        <option key={i} value={u}>{u}</option>
                                    ))}
                                </Field>
                            </div>
                            <div className="form-group col">
                                <label htmlFor="responsable" className='labelFilter'>Responsable</label>
                                <Field id="responsable" name="responsable" className="form-control fieldFilter" as="select" onChange={handleFilterChange}>
                                    <option value="*" defaultValue>*</option>
                                    {options.responsable.map((responsible, i) => (
                                        <option key={i} value={responsible}>{responsible}</option>
                                    ))}
                                </Field>
                            </div>
                            <div className="form-group col">
                                <label htmlFor="estado" className='labelFilter'>Estado</label>
                                <Field id="estado" name="estado" className="form-control fieldFilter" as="select" onChange={handleFilterChange}>
                                    <option value="*" defaultValue>*</option>
                                    <option value="PENDIENTE">PENDIENTE</option>
                                    <option value="PROCESO">PROCESO</option>
                                    <option value="CERRADO">CERRADO</option>
                                    <option value="!CERRADO">NO CERRADO</option>
                                </Field>
                            </div>
                        </div>
                    </Form>
                    );
                }}
            </Formik>
        </div>
    )
}

export default DataFilterTickets;
